import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "src/@/components/ui/dialog";
import { Button } from "src/@/components/ui/button";
import { RadioGroup, RadioGroupItem } from "src/@/components/ui/radio-group";
import { Label } from "src/@/components/ui/label";
import { SelectZui } from 'src/components/zui';
import { SelectItem } from 'src/@/components/ui/select';
import { Switch } from 'src/@/components/ui/switch';
import { Textarea } from 'src/@/components/ui/textarea';

import { verifyFeatures } from 'src/utils/functions';


// ----------------------------------------------------------------------

export default function ModalTransferirChat({
  stateModalTransferirChatProps,
  closeModalTransferirChat,
  valueTransferirChat,
  actionTipoTransferencia,
  valorEscolhidoUsuarioProps,
  valorEscolhidoSetorProps,
  handleUsuario,
  handleSetor,
  handleSelectAgent,
  listaUsuariosProps,
  listaSetoresProps,
  submitTranferirChat,
  onlineUsers,
  loadingTransferirChat,
  cliente,
  chat,
  changeNoteText,
  changeCreateNote,
  noteText,
  createNote
}) {
  const { t } = useTranslation();

  function validaBotaoTransferir() {
    if (valueTransferirChat === '') {
      return true;
    } else {
      if (!valorEscolhidoSetorProps && !valorEscolhidoUsuarioProps) {
        return true;
      } else {
        return false;
      }
    }
  };
  
  const [isSendMessages, setIsSendMessages] = useState(false);
  const [transferProprietary, setTransferProprietary] = useState(false);
  const [isWhatsAppBusinessBlocked, setIsWhatsAppBusinessBlocked] = useState(false);
  // Função para verificar se é WhatsApp Business e se pode enviar mensagem
  const checkWhatsAppBusinessValidity = () => {
    console.log('checkWhatsAppBusinessValidity executada');
    console.log('chat completo:', chat);
    
    if (!chat) {
      console.log('chat não existe');
      return;
    }

    const isWhatsAppBusiness = chat.canal === 'whatsapp_business';

    // Para WhatsApp Business, sempre bloqueia se não tem lastDateMsgClient
    if (isWhatsAppBusiness) {
      if (!chat.lastDateMsgClient) {
        console.log('WhatsApp Business sem lastDateMsgClient - bloqueando');
        setIsWhatsAppBusinessBlocked(true);
        setIsSendMessages(false);
        return true;
      }
      
      const lastMessageDate = new Date(chat.lastDateMsgClient);
      const now = new Date();
      const diffInHours = (now - lastMessageDate) / (1000 * 60 * 60);
      
      console.log('lastMessageDate:', lastMessageDate);
      console.log('diffInHours:', diffInHours);
      
      // Se passou mais de 24 horas, bloqueia o envio de mensagem
      if (diffInHours > 24) {
        console.log('Bloqueando WhatsApp Business - mais de 24h');
        setIsWhatsAppBusinessBlocked(true);
        setIsSendMessages(false);
        return true;
      } else {
        console.log('WhatsApp Business OK - dentro de 24h');
        setIsWhatsAppBusinessBlocked(false);
        return false;
      }
    }
    
    setIsWhatsAppBusinessBlocked(false);
    return false;
  };

  // Executa a validação quando o modal abre ou quando o chat muda
  useEffect(() => {
    checkWhatsAppBusinessValidity();
  }, [chat, stateModalTransferirChatProps]);

  // Log para verificar o estado do bloqueio
  useEffect(() => {

  }, [isWhatsAppBusinessBlocked, isSendMessages]);

  return (

    <Dialog 
      open={stateModalTransferirChatProps} 
      onOpenChange={closeModalTransferirChat}
    >
      <DialogContent className="sm:max-w-[600px]">
        <DialogHeader>
          <DialogTitle>{t('chat.transfer.title')}</DialogTitle>
        </DialogHeader>
        <div className='min-w-[400px] space-y-6'>
          <div className="mt-3">
            <RadioGroup value={valueTransferirChat} onValueChange={actionTipoTransferencia} className="flex flex-row gap-6">
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="setores" id="setores" />
                <Label htmlFor="setores">{t('chat.transfer.sectors')}</Label>
              </div>
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="usuarios" id="usuarios" />
                <Label htmlFor="usuarios">{t('chat.transfer.users')}</Label>
              </div>
            </RadioGroup>
          </div>

          <div className="overflow-hidden space-y-4">
            {valueTransferirChat === 'usuarios' && (
              <div className='flex flex-col gap-4'>
              <SelectZui
                value={valorEscolhidoUsuarioProps}
                list={listaUsuariosProps}
                fullWidth
                onChange={event => {
                  handleUsuario(event);
                }}
                itemSelect={(item) => (
                  <SelectItem key={item._id} value={item._id}>
                    {item.nomeFantasia}
                  </SelectItem>
                )}
              />
              {verifyFeatures(cliente?.features || [], 'chats.wallet') && (
              <div className="flex items-center gap-2">
              <Switch
                id="terms"
                checked={transferProprietary}
                onCheckedChange={value => {
                  setTransferProprietary(value)
                }}
              />
              <label
                htmlFor="terms"
                className="text-xs font-medium"
              >
                {t('chat.transfer.transferOwner')}
              </label>
            </div>
              )}
              </div>
            
            )}


            {valueTransferirChat === 'setores' && (
              <div className='flex flex-col gap-4'>
                <SelectZui
                  value={valorEscolhidoSetorProps}
                  list={listaSetoresProps}
                  fullWidth
                  onChange={event => {
                    handleSetor(event);
                  }}
                  itemSelect={(item) => (
                    <SelectItem key={item._id} value={item._id}>
                      {item.nome_setor}
                    </SelectItem>
                  )}
                />
              </div>
            )}
          </div>

          <div className="flex items-center gap-2">
            <Switch
              id="terms"
              checked={isSendMessages}
              disabled={isWhatsAppBusinessBlocked}
              onCheckedChange={value => {
                if (!isWhatsAppBusinessBlocked) {
                  setIsSendMessages(value)
                  console.log('isSendMessages', value)
                }
              }}
            />
            <label
              htmlFor="terms"
              className={`text-xs font-medium ${isWhatsAppBusinessBlocked ? 'text-gray-500' : ''}`}
            >
              {t('chat.transfer.sendTransferMessage')}
            </label>
          </div>
          
          {isWhatsAppBusinessBlocked && (
            <div className="p-3 bg-yellow-50 border border-yellow-200 rounded-md">
              <p className="text-xs text-yellow-800">
                {'\u26A0\uFE0F '}{t('chat.transfer.whatsappBusinessBlocked', { reason: !chat?.lastDateMsgClient ? t('chat.transfer.reasons.noConversation') : t('chat.transfer.reasons.after24h') })}
              </p>
            </div>
          )}

          <div className="flex items-center gap-2">
            <Switch
              id="createNote"
              checked={createNote}
              onCheckedChange={value => {
                changeCreateNote(value);
                if (!value) {
                  changeNoteText('');
                }
              }}
            />
            <label
              htmlFor="createNote"
              className="text-xs font-medium"
            >
              {t('chat.transfer.createNote')}
            </label>
          </div>

          {createNote && (
            <div className="space-y-2">
              <Label htmlFor="noteText" className="text-xs font-medium">
                {t('chat.transfer.noteLabel')}
              </Label>
              <Textarea
                id="noteText"
                value={noteText}
                onChange={(e) => changeNoteText(e.target.value)}
                placeholder={t('chat.transfer.notePlaceholder')}
                rows={4}
                className="resize-none"
              />
            </div>
          )}

        </div>
        
        <DialogFooter className='mt-12'>
          <Button
            disabled={validaBotaoTransferir() || loadingTransferirChat}
            className='w-full '
            onClick={async () => {
              await submitTranferirChat(isSendMessages, transferProprietary, createNote ? noteText : '');
              setIsSendMessages(true);
              changeCreateNote(false);
              changeNoteText('');
            }}
          >
            {loadingTransferirChat ? t('chat.transfer.transferring') : t('chat.transfer.confirm')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>

  );
}
